// src/components/ArticleHeadlinesKeywordTable.js
import React, { useState } from "react";
import { Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import styles from "page.module.css"; // Update path to your CSS file

const ArticleHeadlinesKeywordTable = ({ data, topic }) => {
  const [copiedIndex, setCopiedIndex] = useState(null); // State to track the copied row

  // Safety check for undefined or null data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">No article headlines available to display.</p>
      </div>
    );
  }

  // Safety check for topic
  if (!topic || typeof topic !== 'string') {
    return (
      <div className="text-center p-4">
        <p className="text-muted">Invalid topic configuration.</p>
      </div>
    );
  }

  const copyToClipboard = (textToCopy, index) => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopiedIndex(index); // Set the copied index when the text is copied
        // Hide the "Copied!" tooltip after 2 seconds
        setTimeout(() => {
          setCopiedIndex(null); // Reset the index after the tooltip hides
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <div className={styles.table_container}>
      <div
        className="table-responsive"
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        <Table hover className="text-wrap text-break">
          <thead>
            <tr>
              <th
                className={`text-left p-1 text-nowrap ${styles.bg_table_header}`}
                style={{
                  backgroundColor: "white",
                  borderRight: "2px solid white",
                }}
              >
                {topic}
              </th>

              <th
                className={`text-center p-1 text-nowrap ${styles.bg_table_header}`}
                style={{
                  backgroundColor: "white",
                  borderRight: "2px solid white",
                }}
              >
                <img
                  src="/copy.png"
                  alt="copy"
                  width={20}
                  height={20}
                  className="me-3 ms-2"
                />
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-top"
                      className={`${styles.custom_tooltip}`}
                    >
                      Click to copy text for quick and easy pasting.
                    </Tooltip>
                  }
                >
                  <img
                    src="/help-green.png"
                    alt="help-green"
                    width={20}
                    height={20}
                    className="me-3 ms-2"
                  />
                </OverlayTrigger>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="text-nowrap">
                  <div className="d-flex align-items-baseline">
                    <span className="me-2">{index + 1}.</span>
                    <strong>{item}</strong>
                  </div>
                </td>
                <td className="text-center align-middle text-nowrap">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-top">
                        {copiedIndex === index ? "Copied!" : "Click to copy"}
                      </Tooltip>
                    }
                  >
                    <div
                      className={`${styles.hover_dark} rounded d-flex justify-content-center align-items-center`}
                    >
                      <img
                        src="/copy.png"
                        alt="copy"
                        width={20}
                        height={20}
                        className="cursor-pointer"
                        onClick={() => copyToClipboard(item, index)}
                      />
                    </div>
                  </OverlayTrigger>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ArticleHeadlinesKeywordTable;
